var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAllowedToAccess)?_c('salesforce-shop-requests'):_vm._e(),_c('number-management'),_c('internet-post'),_c('phoneshop-post'),_c('group-shop'),(_vm.isAllowedToAccess)?_c('InternetShopCustomForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }